/* ORIIVE — Quick add depuis « Compléter votre look » */
(function () {
  'use strict';
  function resolve(card) {
    var data;
    try { data = JSON.parse(card.getAttribute('data-look-variants') || '[]'); } catch (e) { data = []; }
    var sSel = card.querySelector('[data-look-opt="s"]');
    var cSel = card.querySelector('[data-look-opt="c"]');
    var s = sSel ? sSel.value : '';
    var c = cSel ? cSel.value : '';
    var needSize = sSel && sSel.tagName === 'SELECT' && !s;
    var match = data.filter(function (v) {
      return (!sSel || String(v.s) === String(s)) && (!cSel || String(v.c) === String(c));
    });
    var avail = match.filter(function (v) { return v.a; });
    return { needSize: needSize, variant: avail[0] || match[0] || null };
  }

  function variantsOf(card) {
    try { return JSON.parse(card.getAttribute('data-look-variants') || '[]'); } catch (e) { return []; }
  }
  function syncImg(card) {
    var cSel = card.querySelector('[data-look-opt="c"]');
    if (!cSel) return;
    var c = cSel.value;
    var withImg = variantsOf(card).filter(function (v) { return String(v.c) === String(c) && v.img; });
    var url = withImg[0] ? withImg[0].img : null;
    if (!url) return;
    var img = card.querySelector('.pdp2-look__media img');
    if (img && img.getAttribute('src') !== url) {
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url;
    }
  }
  function initLook() {
    document.querySelectorAll('[data-look-card]').forEach(syncImg);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLook);
  } else { initLook(); }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-look-opt="c"]');
    if (!sel) return;
    var card = sel.closest('[data-look-card]');
    if (card) syncImg(card);
  });

  function openCart() {
    var btn = document.querySelector('.oriive-header__cart');
    if (btn) { btn.click(); return; }
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-look-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-look-card]');
    if (!card) return;
    var r = resolve(card);
    if (r.needSize) {
      var ss = card.querySelector('[data-look-opt="s"]');
      if (ss) { ss.style.borderColor = '#B23A3A'; ss.focus(); }
      return;
    }
    if (!r.variant) { btn.classList.add('is-err'); btn.textContent = 'Indisponible'; return; }
    var orig = btn.getAttribute('data-label') || 'Ajouter';
    btn.disabled = true; btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: r.variant.id, quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); })
      .then(function () {
        btn.disabled = false; btn.classList.remove('is-err'); btn.classList.add('is-added'); btn.textContent = 'Ajouté ✓';
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        setTimeout(openCart, 150);
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = orig; }, 2600);
      })
      .catch(function () {
        btn.disabled = false; btn.classList.add('is-err'); btn.textContent = 'Réessayer';
        setTimeout(function () { btn.classList.remove('is-err'); btn.textContent = orig; }, 2000);
      });
  });
})();

